// 资料预览抽屉的开关放在地址里（?doc=<资料>&kb=<知识库>）：能分享、能后退关掉，任何页面都能打开。
import { useCallback } from 'react'
import { useSearchParams } from 'react-router'

export function useDocPreview() {
  const [params, setParams] = useSearchParams()
  const open = useCallback(
    (knowledgeId: string, kbId?: string) =>
      setParams((p) => {
        const next = new URLSearchParams(p)
        next.set('doc', knowledgeId)
        if (kbId) next.set('kb', kbId)
        else next.delete('kb')
        return next
      }),
    [setParams],
  )
  const close = useCallback(
    () =>
      setParams((p) => {
        const next = new URLSearchParams(p)
        next.delete('doc')
        next.delete('kb')
        return next
      }),
    [setParams],
  )
  return { docId: params.get('doc'), kbId: params.get('kb'), open, close }
}
